import { Config } from "./Configs";

export enum SESSION_STATUS {
  STANDBY = "STANDBY",
  READY = "READY",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETE = "COMPLETE",
}

export type Session = {
  _id: string;
  configId: string;
  status: SESSION_STATUS;
  startDate: Date;
  endDate: Date;
  createdDate: Date;
  containers: string[];
  matches: string[];
  config: Config;
};
